import EmployeeEmploymentMenu from "./EmployeeEmploymentMenu";

import styles from "../styles/Employee.module.css";

function EmployeeEmployment({
  getPage = () => { },
  handleMenuChange = () => { },
}) {
  return (
    <div className={styles.selector}>
      <EmployeeEmploymentMenu onChange={handleMenuChange} />
    </div>
  );
}

export default EmployeeEmployment;
